import * as React from 'react'
import { connect } from 'react-redux'

import { IRootState } from '../../../../common/reducers'

import NarrowEmptyItemCard from './narrowEmptyItemCard'

interface IStateProps {
  viewType: string
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { user: { preferences: { searchResultsViewType } } } = state
  return { viewType: searchResultsViewType }
}

const NarrowEmptyItemCardContainer = connect<IStateProps, {}, any, IRootState>(
  mapStateToProps
)(NarrowEmptyItemCard)

export default NarrowEmptyItemCardContainer
